import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { LOGO_ICON_LIGHT_URL } from "../emails/emailBrand";

const listFn = httpsCallable(functions, "listEmailTemplates");
const previewFn = httpsCallable(functions, "getEmailPreview");
const sendTestFn = httpsCallable(functions, "sendTestEmail");

export function isLogoUrlPending() {
  return String(LOGO_ICON_LIGHT_URL || "").startsWith("REPLACE_ME");
}

export async function listEmailTemplates() {
  const { data } = await listFn({});
  return data?.templates || [];
}

export async function getEmailPreview(templateKey) {
  const { data } = await previewFn({ templateKey });
  return data;
}

export async function sendTestEmail(templateKey) {
  const { data } = await sendTestFn({ templateKey });
  return data;
}
